import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "@/hooks/useCart";
import CartDrawer from "@/components/feature/CartDrawer";
import ScrollRestoration from "@/hooks/useScrollRestoration";
import HeroLoader from "@/components/feature/HeroLoader";

function AnimatedRoutes() {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-enter">
      <AppRoutes />
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CartProvider>
          <ScrollRestoration />
          <HeroLoader />
          <AnimatedRoutes />
          <CartDrawer />
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;